<template>
  <div class="content">
    <div style="position: fixed;right:10px;top:300px;z-index:1000">
      <Rightnav @showsp="getshow" @runtops="runtop"></Rightnav>
    </div>
    <transition name="slide-fade">
      <div class="Mask" v-if="showquote">
        <div class="mask-main">
          <i @click="mask" class="iconfont icon-guanbi"></i>
          <Freequote></Freequote>
        </div>
      </div>
    </transition>
    <div class="banane">
      <el-carousel indicator-position="outside" height="500px">
        <el-carousel-item v-for="(item,index) in msg2" :key="index">
          <img v-lazy="item.imgurl" oncontextmenu="return false;"/>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="main">
      <div class="main-Designer" v-for="(item,index) in sjlist.list" :key="index" >
        <div class="main-one" @click="jump(item)">
          <div class="character" >
            <img
              :src="item.userpic"
              v-if="item.userpic!=='' && item.userpic!==null && item.userpic!=='null'"
            />
            <img
              v-if="item.userpic=='' || item.userpic==null || item.userpic=='null'"
              src="../assets/images/test.jpg"
              alt
            />
          </div>
          <div class="information">
            <div class="name">
              <span style="color: #000;font-size: 22px;">{{item.allname}}</span>
              <div style="color:#666;font-size: 16px; margin-top:9px;">{{item.comname}}</div>
              <!-- <span style="margin-left:10px;color:#666;font-size: 13px;">优秀设计师</span>
            <span style="margin-left:10px;">
              <i class="iconfont icon-xingxing"></i>
              <i class="iconfont icon-xingxing"></i>
              <i class="iconfont icon-xingxing"></i>
              <i class="iconfont icon-xingxing"></i>
              <i class="iconfont icon-xingxing"></i>
              </span>-->
            </div>
            <p class="Slogan" v-if="item.usermemo!=='' && item.usermemo!=='null' && item.uermemo!=='undefined'">{{item.usermemo}}</p>
            <p class="Slogan" v-if="item.usermemo=='' || item.usermemo=='null' || item.uermemo=='undefined'">生活有我更精彩,设计由我更精彩</p>
          </div>
        </div>
        <div class="case">
          <!-- <div style="color: #b31d25;text-align: left;">精品案例</div> -->
          <ul>
            <li @click="toqjt(ites.designid)" v-for="(ites,index) in item.itemdata" :key="index">
              <div class="bran-father">
                <img :src="ites.img" v-if="index<3" oncontextmenu="return false;" />
                <div class="brand">桔家云</div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="bananes">
        <img src="../assets/images/WechatIMG250.png" oncontextmenu="return false;" />
      </div>
    </div>
    <div class="page">
      <el-pagination
        :page-size="16"
        :current-page.sync="page"
        @current-change="handlecurrentchange"
        background
        layout="prev, pager, next"
        :total="sjlist.totalCount"
      ></el-pagination>
    </div>

    <div>
      <BottomFoot></BottomFoot>
    </div>
  </div>
</template>
<script>
import Vue from "vue";

import BottomFoot from "../components/BottomFoot.vue";
import Freequote from "../components/Freequote.vue";
import Rightnav from "../components/Rightnav.vue";
export default {
  components: {

    BottomFoot,
    Freequote,
    Rightnav
  },
  metaInfo() {
    return {
      meta: [
        {
          name: "description",
          content:
            "家装设计师、室内设计师、装修设计师、大咖云集、整装桔家云整装，汇聚百位大咖装修设计师，为您提供各种风格，各种面积，各种户型的设计方案，一对一专业服务。"
        }
      ]
    };
  },
  data() {
    return {
      msg2:[
        { imgurl: require("../assets/images/shejisi/WechatIMG254.jpeg"), name: "1" },
        { imgurl: require("../assets/images/shejisi/banner.png"), name: "2" }
        
      ],
      nub: "7",
      showquote: false,
      value5: 5,
      page: 1,
      sjlist: [],
      posdata: ""
    };
  },
  methods: {
    getshow(data) {
      // console.log("data", data);
      this.showquote = data;
    },
    getpositions(data) {
      // console.log('datass',data);
      this.posdata = data;
      this.postsde();
    },
    mask() {
      this.showquote = false;
    },
    runtop(data) {
      document.documentElement.scrollTop = data;
    },
    handlecurrentchange(size) {
      this.page = size;
      this.postsde();
    },
    postsde: async function() {
      let data = {
        province: this.posdata.province,
        city: this.posdata.city,
        // area:this.posdata.area,
        area: "",
        page: this.page,
        limit: 16
      };
      let res = await this.exequy.postshejis(data);
      this.sjlist = res.data.data;
    },
    toqjt(item) {
      // let data = {
      let id = item;
      //   routername: 'Designer',
      //   pagename: '精选设计师',
      //   currentpage : '效果图详情'
      // }
      this.$router.push({ path: "/Casedetails", query: { id: id } });
    },
    jump(item) {
      //console.log("kkkk", item.userid);
      this.$router.push({
        path: "/DesignerDetails",
        query: { resl: item.userid }
      });
    }
  },
  created: async function() {
    let self = this;
  }
};
</script>
<style scoped>
img {
  width: 100%;
}
.content {
  width: 100%;
}
.head {
  width: 100%;
  overflow: hidden;
  position: fixed;
  top: 0;
  z-index: 1000;
}
.banane >>> .el-carousel__arrow {
  height: 70px;
  width: 70px;
  font-size: 35px;
}
.banane >>> .el-carousel__arrow--left{
  left: 60px;
}
.banane >>> .el-carousel__arrow--right{
  right: 60px;
}
.main {
  width: 1340px;
  margin: 0 auto;
  overflow: hidden;
}
.banane {
  width: 100%;
  
}
.banane img {
  margin:0 auto;
  width: 100%;
  height: 100%;
}
.main-Designer {
  width: 39%;
  margin-left: 10%;
  height: 17rem;
  float: left;
  margin-top: 1rem;
  cursor: pointer;
  margin-bottom: 1rem;
  /* background: rgb(242, 242, 242); */
  border: 1px solid #ddd;
  padding: 10px;
}
.main-one {
  width: 100%;
  height: 50%;
  cursor: pointer;
}
.main-Designer:nth-child(even) {
  margin-left: 2%;
}
.main-Designer:hover {
  box-shadow: 5px 5px 3px #f1f1f1;
}
.character {
  width: 130px;
  height: 130px;
  border-radius: 50%;
  float: left;
  overflow: hidden;
}
.information {
  margin-top: 3%;
  width: 55%;
  float: left;
  text-align: left;
  padding-left: 28px;
}
.icon-xingxing {
  color: #facc48;
}
.Slogan {
  line-height: 20px;
  color: #333;
  font-size: 15px;
}
.case {
  /* margin-top: 3rem; */
  width: 100%;
  overflow: hidden;
  cursor: pointer;
}
.case ul {
  margin-top: 25px;
  margin-left: -2%;
  padding-inline-start: 0px;
}
.case ul li {
  width: 27%;
  list-style: none;
  float: left;
  margin-left: 4%;
}
.case ul li img {
  height: 85px;
}
.case .bran-father {
  position: relative;
}
.case .brand {
  width: 45px;
  height: 18px;
  background: #b31d25;
  position: absolute;
  top: 0px;
  right: 0px;
  color: #fff;
  line-height: 20px;
  font-size: 13px;
}
.bananes {
  width: 80%;
  height: 500px;
  margin: 0 auto;
}
.bananes img {
  width: 100%;
  height: 100%;
}
.Mask {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 1000;
}
.mask-main {
  border-radius: 15px;
  text-align: center;
  width: 50%;
  height: 60%;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  background-color: white;
  z-index: 10000;
}
.icon-guanbi {
  font-size: 25px;
  position: absolute;
  right: 11px;
  top: 5px;
  line-height: normal;
}
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
.page {
  margin-bottom: 15px;
}
</style>
